const MISTRAL_API_ENDPOINT = 'https://api.mistral.ai/v1/chat/completions';

export const generateMistralResponse = async (
  apiKey: string, 
  systemPrompt: string, 
  userMessage: string
): Promise<string> => {
  console.log('Iniciando chamada à API Mistral...');
  
  try {
    if (!apiKey) {
      console.error('Chave API não fornecida');
      throw new Error('Chave API não fornecida');
    }

    const response = await fetch(MISTRAL_API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: 'mistral-tiny',
        messages: [
          {
            role: 'system',
            content: systemPrompt
          },
          {
            role: 'user',
            content: userMessage
          }
        ],
        temperature: 0.7,
        max_tokens: 1000,
      }),
    });

    console.log('Status da resposta:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Erro na resposta da API:', {
        status: response.status,
        statusText: response.statusText,
        errorText
      });
      
      if (response.status === 401) {
        throw new Error('Chave API inválida ou expirada');
      }
      
      throw new Error(`Erro na API: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    console.log('Resposta da API recebida:', data);
    
    if (!data?.choices?.[0]?.message?.content) {
      console.error('Resposta inválida da API:', data);
      throw new Error('Resposta inválida da API Mistral');
    }

    return data.choices[0].message.content;
  } catch (error) {
    console.error('Erro detalhado ao gerar resposta:', error);
    
    if (error instanceof Error) {
      if (error.message.includes('Failed to fetch')) {
        throw new Error('Erro de conexão com a API. Verifique sua conexão com a internet.');
      }
      throw new Error(`Falha ao obter resposta do Mistral AI: ${error.message}`);
    }
    
    throw new Error('Falha ao obter resposta do Mistral AI');
  }
};